import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { residueService } from "@/services/residue/residueService";

export const useResidueActions = () => {
    const { toast } = useToast();
    const { t } = useLanguage();
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async (id: string) => {
        try {
            setIsLoading(true);
            await residueService.delete(id, user?.uid);
            toast({
                title: t("success"),
                description: t("residues.deleted"),
            });
        } catch (error) {
            console.error("Error deleting residue:", error);
            toast({
                title: t("error"),
                description: t("residues.deleteError"),
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleDelete,
        isLoading,
    };
}; 